module.exports = __webpack_public_path__ + "static/media/img_agency_optimized.dfafc78c.jpg";